// SearchCreator.jsx
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import SearchCreatorList from '../container/SearchCreatorList.js';

import Loading from '../component/Loading.jsx';

import { TranslationNamespace } from '../resource/translationNamespace.js';

import { textColor } from '../style/variables.js';

import EmptyResultIconResource from '../../img/img-empty-nofollowing.svg';

export class SearchCreator extends React.PureComponent {
  fetchData = () => {
    const {
      sortingString,
      query,
      defaultSwaggerCategory,
      hasQuery,
      isActive,
      fetchUserSearch,
      fetchFeeds,
      isRemoteConfigMerged,
    } = this.props;
    if (!isActive) {
      return;
    }
    if (hasQuery) {
      return fetchUserSearch({
        query,
        sortings: sortingString.split('&').filter(i => i),
      });
    }
    if (isRemoteConfigMerged && defaultSwaggerCategory) {
      return fetchFeeds({
        type: defaultSwaggerCategory,
      });
    }
    return;
  };
  componentDidMount() {
    this.fetchData();
  }
  componentDidUpdate(prevProps) {
    const { query, category, isAuthed, isActive, isRemoteConfigMerged } =
      this.props;
    if (
      isAuthed !== prevProps.isAuthed ||
      query !== prevProps.query ||
      category !== prevProps.category ||
      isActive !== prevProps.isActive ||
      isRemoteConfigMerged !== prevProps.isRemoteConfigMerged
    ) {
      this.fetchData();
    }
  }
  render() {
    const {
      type,
      category,
      isSwaggerFetched,
      swaggerIds,
      t,
      shouldDisplayEmptyPlaceholder,
    } = this.props;
    const isLoading = !isSwaggerFetched;
    const isEmpty = swaggerIds.length === 0;
    if (isEmpty && shouldDisplayEmptyPlaceholder) {
      // only show loading when list is empty to prevent scroll height loss.
      if (isLoading) {
        return (
          <StyledSearchAll>
            <LoadingWrapper>
              <Loading />
            </LoadingWrapper>
          </StyledSearchAll>
        );
      }
      return (
        <StyledSearchAll>
          <EmptyResultWrapper>
            <EmptyResultIcon src={EmptyResultIconResource} />
            {t('search_no_result', {
              ns: TranslationNamespace.SEARCH,
            })}
          </EmptyResultWrapper>
        </StyledSearchAll>
      );
    }
    return (
      <StyledSearchAll>
        <SearchCreatorList type={type} category={category} />
      </StyledSearchAll>
    );
  }
}

SearchCreator.propTypes = {
  sortingString: PropTypes.string,
  query: PropTypes.string,
  type: PropTypes.string,
  category: PropTypes.string,
  defaultSwaggerCategory: PropTypes.string,
  isAuthed: PropTypes.bool,
  isSwaggerFetched: PropTypes.bool,
  hasQuery: PropTypes.bool,
  isActive: PropTypes.bool,
  swaggerIds: PropTypes.array,
  fetchFeeds: PropTypes.func,
  fetchUserSearch: PropTypes.func,
  t: PropTypes.func.isRequired,
  shouldDisplayEmptyPlaceholder: PropTypes.bool,
  isRemoteConfigMerged: PropTypes.bool,
};

SearchCreator.defaultProps = {
  sortingString: '',
  query: '',
  type: '',
  category: '',
  defaultSwaggerCategory: '',
  isAuthed: false,
  isSwaggerFetched: false,
  hasQuery: false,
  isActive: false,
  swaggerIds: [],
  fetchFeeds: () => null,
  fetchUserSearch: () => null,
  shouldDisplayEmptyPlaceholder: true,
  isRemoteConfigMerged: false,
};

const StyledSearchAll = styled.div``;

const LoadingWrapper = styled.div`
  margin-top: 40px;
`;

const EmptyResultWrapper = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${textColor.black};
  font-size: 14px;
`;

const EmptyResultIcon = styled.img`
  margin-bottom: 12px;
  height: 120px;
  width: auto;
`;

export default withTranslation()(SearchCreator);
